class NavigationFull {
	constructor() {
		this.navigationFull();
	}

	navigationFull() {
		// selectNavItem('navigation-full', '', 0);
		disabledLinks('navigation-full', 'disabled');
		parentFullNavItem();

		function disabledLinks(navigation, className) {
			const links = document.querySelectorAll(`.${navigation} a.${className}`);
			links.forEach(link => {
				link.removeAttribute('href');
			})
		}

		function selectNavItem(navClass, page, navPosition) {
			const urlAll = document.URL;
			const beginPosition = urlAll.lastIndexOf("/");
			const endPosition = urlAll.length;
			const urlPart = urlAll.substring(beginPosition + 1, endPosition);

			if (urlPart === page) {
				document.querySelectorAll("." + navClass + " > ul > li")[navPosition].classList.add("active");
				document.querySelectorAll("." + navClass + " > ul > li")[navPosition].querySelector("a").classList.add("active");
			}
		}

		function parentFullNavItem() {
			const submenuItems = document.querySelectorAll('.navigation-full .menu .has-submenu .submenu .menu-item');
			const submenuItems2 = document.querySelectorAll('.navigation-full .menu .has-submenu .submenu .menu-item.has-submenu .submenu .menu-item');

			// console.log(submenuItems);
			// console.log(submenuItems2);

			for (let i = 0; i < submenuItems.length; i++) {
				if (submenuItems[i].classList.contains('active')) {
					const parentItem = submenuItems[i].closest('.has-submenu');
					parentItem.classList.add('active');
				}
			}

			for (let i = 0; i < submenuItems2.length; i++) {
				if (submenuItems2[i].classList.contains('active')) {
					const parentItem = submenuItems2[i].closest('.has-submenu');
					parentItem.classList.add('active');
				}
			}
		}
	}
}

new NavigationFull();
